module.exports = __webpack_public_path__ + "img/balance.35979b26.svg";